<template>
  <div class="modal" v-if="seen">
    <div class="upload_browse_folder">
      <div class="" style="padding: 1.2em">
        <div
          class="d-flex justify-content-between align-items-center"
          v-if="!add"
        >
          <h4>{{ title }} to...</h4>
          <span @click="closebox" class="close_advanced_search">
            <img src="@/assets/search-icons/Close.svg" />
          </span>
        </div>
        <div class="error-msg" v-if="error">
          <span>Please select a folder</span>
        </div>
        <div
          class="d-flex justify-content-between align-items-center"
          v-if="add"
        >
          <h4
            style="font-size: 14px"
            class="d-flex justify-content-center align-items-center mb-0"
          >
            <span class="close_advanced_search" @click="cancel"
              ><svg
                class="mdi-icon"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
                ></path></svg
            ></span>
            <span class="ml-2">Create New Folder</span>
          </h4>
          <span @click="closebox" class="close_advanced_search">
            <img src="@/assets/search-icons/Close.svg" />
          </span>
        </div>
        <div class="input mt-3" v-if="add">
          <label> Folder Name </label>
          <input
            type="text"
            v-model="filename"
            ref="file"
            id="file"
            placeholder="Enter folder name"
            autocomplete="false"
          />
          <span class="error" v-if="specialChar_error">{{
            specialChar_error
          }}</span>
          <span class="error" v-if="exist">*File already exist</span>
          <span class="error" v-if="error">*Required</span>
        </div>
        <div class="browse_folder_nav mb-3" v-if="current_index.length">
          <browse-folder-breadcrumb
            :path="current_index"
            @browse_dir="browse_dir"
          ></browse-folder-breadcrumb>
        </div>
        <div class="browse_folders" :class="{ 'mt-3': !current_index.length }">
          <template v-if="folders.length">
            <ul class="selected_folders">
              <li
                v-for="(name, index) in folders"
                :key="index"
                :class="{ highlighted: name.highlighted }"
                @click="browse(index)"
              >
                <span @click="highlight(index)">
                  <template v-if="name.group == 'PUBLIC'">
                    <img
                      src="@/assets/icons/folder/Public.svg"
                      height="32px"
                      width="32px"
                    />
                  </template>
                  <template v-if="name.group == 'GROUP'">
                    <img
                      src="@/assets/icons/folder/Group.svg"
                      height="32px"
                      width="32px"
                    />
                  </template>
                  <template v-if="name.group == 'PROJECT'">
                    <img
                      src="@/assets/icons/folder/Project.svg"
                      height="32px"
                      width="32px"
                    />
                  </template>
                  <template v-if="name.group == 'PERSONAL'">
                    <img
                      src="@/assets/icons/folder/General.svg"
                      height="32px"
                      width="32px"
                    />
                  </template>
                  &nbsp;&nbsp;
                  <span class="dir">
                    {{ name.dir }}
                  </span>
                </span>
              </li>
            </ul>
          </template>
          <template v-else>
            <EmptyIllustration />
            <span>No folder found</span>
          </template>
        </div>
      </div>
      <div
        class="buttons d-flex align-items-center"
        :class="{
          'justify-content-between': !add,
          'justify-content-center': add,
        }"
      >
        <template v-if="!add">
          <span
            class="create_new_folder"
            :class="{ hover: hover }"
            @click="new_folder"
            @mouseenter="create_new_hover"
            @mouseleave="create_new_hover_out"
          >
            <template v-if="hover">
              <img src="@/assets/add-new-white.svg" />&nbsp;&nbsp;<span
                >New Folder</span
              >
            </template>
            <template v-else>
              <img src="@/assets/add-new.svg" />&nbsp;&nbsp;<span
                >New Folder</span
              >
            </template>
          </span>
          <template v-if="title == 'Move'">
            <span class="upload_file" @click="movefile">
              <img src="@/assets/Move.svg" /> &nbsp;&nbsp;
              <span>{{ title }} Here</span>
            </span>
          </template>
          <template v-else>
            <span class="upload_file" @click="copyfile">
              <img src="@/assets/Move.svg" v-if="title == 'Move'" />
              <img src="@/assets/copy-icon.svg" v-if="title == 'Copy'" />
              &nbsp;&nbsp;
              <span>{{ title }} Here</span>
            </span>
          </template>
        </template>
        <template v-else>
          <template v-if="loading">
            <span class="create_file" style="cursor: not-allowed">
              <span>Please Wait....</span>
            </span>
          </template>
          <template v-else>
            <span class="create_file" @click="send">
              <img src="@/assets/add-new-white.svg" /> &nbsp;&nbsp;
              <span>Create New Folder</span>
            </span>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<style scoped>
.error-msg {
  text-align: left;
}
.error-msg span {
  color: #fc6d6c;
  font-size: 15px;
}
.input {
  display: flex;
  flex-direction: column;
  justify-content: left;
}
.input label {
  font-size: 14px;
  color: #4b5458;
  text-align: left;
}
.input input {
  border: 1px solid #a7b9cb;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 10px 12px;
  margin: 0 0 10px;
}
.input .error {
  text-align: left;
  color: #fc6d6c;
  font-size: 14px;
}

.create_file {
  background: #3f96d1;
  cursor: pointer;
  border-radius: 8px;
  width: 182px;
  height: 42px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.highlighted {
  background: #d9ecfa !important;
  padding-left: 8px !important;
}
.selected_folders li:hover {
  background: #d9ecfa !important;
  padding-left: 8px !important;
}
.buttons {
  background: #ffffff;
  box-shadow: 0px -4px 40px rgba(0, 0, 0, 0.06);
  padding: 1.3em 1.2em;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.selected_folders {
  height: 320px;
  overflow-y: auto;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.selected_folders li {
  padding-left: 0;
}

.hover {
  background: #3f96d1 !important;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 42px;
  color: #fff !important;
  border: 1px solid #3f96d1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}
.browse_folder_nav {
  text-align: left;
}
.close_advanced_search {
  background: #f2f7fc;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.create_new_folder {
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 42px;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.upload_file {
  background: #3f96d1;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 42px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.btn-save {
  background: transparent;
  cursor: pointer;
  border-radius: 5px;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.4em 0.6em;
  height: 40px;
}

.folder-name {
  border-radius: 8px;
  border: 1px solid #a7b9cb;
  padding: 0.6em 0.6em;
  width: 100%;
  flex-basis: auto;
}
.action-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
}
.btn-cancel {
  background: #fc6d6c;
  cursor: pointer;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.4em 0.6em;
  height: 40px;
}
.upload_browse_folder {
  background: #fff;
  border-radius: 8px;
  width: 460px;
}
.modal {
  display: flex;
}
.cgn {
  display: flex;
  flex-direction: column;
}
.cgn span {
  margin-bottom: 0.4em;
}
</style>

<script>
import cookies from "@/services/cookies";
import { mapMutations } from "vuex";
import BrowseFolderBreadcrumb from "@/components/Browse-Folder-Breadcrumb";
import EmptyIllustration from "@/components/EmptyIllustration";
export default {
  components: {
    BrowseFolderBreadcrumb,
    EmptyIllustration,
  },
  data() {
    return {
      names: [],
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      current_index: [],
      current_name: "My Space",
      selected_index: null,
      selected_files: [],
      type: "",
      title: "",
      is_shared: false,
      add: false,
      filename: "",
      specialChar_error: false,
      exist: false,
      hover: false,
      loading: false,
      current: null,
    };
  },
  computed: {
    folders: function () {
      let that = this;
      return this.names.filter(function (name) {
        return !that.selected_files.includes(name.id);
      });
    },
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "UPDATE_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "UPDATE_TOTAL_USED_SPACE",
    ]),
    create_new_hover() {
      this.hover = true;
    },
    create_new_hover_out() {
      this.hover = false;
    },
    cancel() {
      this.add = false;
      this.hover = false;
    },
    logincall() {
      this.$parent.logincall();
    },
    new_folder() {
      this.add = true;
    },
    str_text(str) {
      return str.length > 22 ? str.substr(0, 22) + "..." : str;
    },
    highlight(index) {
      if (this.names[index].group == "GROUP") {
        this.type = "group-folder";
      }

      if (
        this.names[index].group == "PERSONAL" ||
        this.names[index].group == "PUBLIC" ||
        this.names[index].group == "PROJECT"
      ) {
        this.type = "folder";
      }
      this.dir = this.names[index];
      this.current_directory_id = this.names[index].id;
      this.names = this.names.map((name) => {
        name.highlighted = false;
        return name;
      });
      this.names[index].highlighted = true;
      this.current = {
        id: this.names[index].id,
        name: this.names[index].name,
        db: this.names[index].db,
        is_shared: this.is_shared,
      };
    },
    specialChar(str) {
      let specialChars = '<>*?:|"\\/';
      let found = "";
      for (let i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          found += specialChars[i];
        }
      }
      return found;
    },
    send() {
      this.error = false;
      this.specialChar_error = "";

      if (this.filename === "") {
        this.error = true;
      } else {
        if (this.specialChar(this.filename)) {
          this.specialChar_error =
            this.specialChar(this.filename) + " are not allowed";
          return;
        }

        this.loading = true;

        if (this.type == "folder") {
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            db: localStorage.getItem("db"),
            current_directory_id: this.current_directory_id,
          };

          let that = this;

          this.$socket.emit("create-folder", data, async function (data) {
            if (data.data === true) {
              if (data.found === 1) {
                that.loader = false;
                that.exist = true;
              } else {
                that.loading = false;
                that.add = false;
                that.hover = false;
                that.names = [];

                let name = data.du.name;
                that.filename = "";

                let db = "";
                if (data.du.group == "GROUP") {
                  db = "group";
                }

                if (data.du.group == "PERSONAL") {
                  db = "filesystem";
                }

                if (data.du.group == "PUBLIC") {
                  db = "public";
                }
                that.current_directory_id = data.du._id;
                that.current_index.push({
                  id: data.du._id,
                  db: db,
                  is_public: data.du.group == "PUBLIC",
                  is_group: data.du.group == "GROUP",
                  parent_id: data.du.parent_id,
                  name: name,
                  is_default: data.du.is_default,
                });
                that.current = { id: data.du._id, name: data.du.name, db: db };
              }
            }

            if (data.data === false) {
              that.seen = false;
              that.$parent.logincall();
              that.$router.push('/login')
            }
          });
        }

        if (this.type == "group-folder") {
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            current_directory_id: this.current_directory_id,
          };

          let that = this;

          if (this.$store.getters.ISADMIN) {
            this.$socket.emit(
              "create-group-folder",
              data,
              async function (data) {
                if (data.data === true) {
                  if (data.found === 1) {
                    that.loader = false;
                    that.exist = true;
                  } else {
                    that.loading = false;
                    that.add = false;
                    that.hover = false;
                    that.names = [];

                    let name = data.du.name;
                    that.filename = "";

                    let db = "";
                    if (data.du.group == "GROUP") {
                      db = "group";
                    }

                    if (data.du.group == "PERSONAL") {
                      db = "filesystem";
                    }

                    if (data.du.group == "PUBLIC") {
                      db = "public";
                    }

                    that.current_directory_id = data.du._id;
                    that.current_index.push({
                      id: data.du._id,
                      db: db,
                      is_public: data.du.group == "PUBLIC",
                      is_group: data.du.group == "GROUP",
                      parent_id: data.du.parent_id,
                      name: name,
                      is_default: data.du.is_default,
                    });
                    that.current = {
                      id: data.du.id,
                      name: data.du.name,
                      db: db,
                    };
                  }
                }

                if (data.data === false) {
                  that.seen = false;
                  that.$parent.logincall();
                  that.$router.push('/login')
                }
              }
            );
          } else {
            this.$socket.emit(
              "create-group-folder-approval",
              data,
              async function (data) {
                if (data.data === true) {
                  if (data.found === 1) {
                    that.loader = false;
                    that.exist = true;
                  } else {
                    that.loading = false;
                    that.hover = false;
                    that.add = false;

                    let name = data.du.name;
                    that.filename = "";
                    that.names = [];

                    let db = "";
                    if (data.du.group == "GROUP") {
                      db = "group";
                    }

                    if (data.du.group == "PERSONAL") {
                      db = "filesystem";
                    }

                    if (data.du.group == "PUBLIC") {
                      db = "public";
                    }

                    that.current_directory_id = data.du._id;
                    that.current_index.push({
                      id: data.du._id,
                      db: db,
                      is_public: data.du.group == "PUBLIC",
                      is_group: data.du.group == "GROUP",
                      parent_id: data.du.parent_id,
                      name: name,
                      is_default: data.du.is_default,
                    });
                    that.current = {
                      id: data.du.id,
                      name: data.du.name,
                      db: db,
                    };
                  }
                }

                if (data.data === false) {
                  that.seen = false;
                  that.$parent.logincall();
                  that.$router.push('/login')
                }
              }
            );
          }
        }
      }
    },
    browse_dir(dir) {
      let that = this;

      let data = {
        token: cookies.getCookie("token"),
        id: dir[1],
      };

      this.current_directory_id = dir[1];

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
          that.current_index.pop();
          that.selected_index = that.names.length - 1;
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    back() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
          that.current_index = [];
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    browse(index) {
      this.error = false;

      let that = this;
      let id = this.names[index].id;
      let is_public = this.names[index].is_public;
      let is_group = this.names[index].is_group;
      let db = this.names[index].db;
      let parent_id = this.names[index].parent_id;
      let name = this.names[index].dir;
      let is_default = this.names[index].is_default === true;

      if (!this.names[index].hasChild) {
        this.current_index.push({
          id: id,
          db: db,
          is_public: is_public,
          is_group: is_group,
          parent_id: parent_id,
          name: name,
          is_default: is_default,
        });
        this.current_name = name;
        that.names = [];
        that.current = { id: id, name: name, db: db };
        return;
      }

      let data = {
        token: cookies.getCookie("token"),
        id: this.names[index].id,
      };

      this.current_directory_id = this.names[index].id;

      that.names = [];

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
          that.current_index.push({
            id: id,
            db: db,
            is_public: is_public,
            is_group: is_group,
            parent_id: parent_id,
            name: name,
            is_default: is_default,
          });
          that.current = { id: id, name: name, db: db };
          that.current_name = name;
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    load(type) {
      let that = this;
      this.seen = true;
      this.names = [];
      this.current_index = [];
      this.current_name = "My Space";
      this.type = type;
      this.selected_index = null;
      this.selected_files = [];
      this.title = type == "copy" ? "Copy" : "Move";

      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    copyfile() {
      if (this.current == null) {
        this.error = true;
      } else {
        this.seen = false;
        this.$parent.groupcopyfile(this.current.id, this.current.name);
      }
    },
    movefile() {
      if (this.current == null) {
        this.error = true;
      } else {
        this.seen = false;
        this.$parent.groupmovefile(this.current.id, this.current.name);
      }
    },
    closebox() {
      this.names = [];
      this.selected_files = [];
      this.selected_index = null;
      this.seen = false;
    },
  },
};
</script>
